import { Select } from "antd";
import { useEffect } from "react";
import { SizeType } from "antd/es/config-provider/SizeContext";
import { useSelector } from "react-redux";
import store from "../../../../controllers/store";
import { find } from "../../../../controllers/store/actions/roles/get-roles-actions";
import { PageSetting, RoleType, RoleTypeMap } from "../../..";

interface Props {
  onChange: (value: string) => void;
  size?: SizeType;
  onClear: () => void;
  mode?: any;
  defaultValue?: any;
  style?: any;
}
const dispatch = store.dispatch;
const SelectRoles = (props: Props) => {
  const rolesState = useSelector((state: any) => state.roles);

  useEffect(() => {
    dispatch(find(PageSetting.page, PageSetting.limit, {} as any));
    console.log("rolesState", rolesState);
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <Select
        {...props}
        allowClear
        labelInValue
        size={props.size}
        defaultValue={props.defaultValue}
        style={props.style}
        onChange={(value: any) => {
          props.onChange(value);
        }}
        options={
          rolesState?.list
            .filter(
              (r: any) =>
                r.name === RoleType.InstitutionalAdmin ||
                r.name === RoleType.KnowledgeConsumer ||
                r.name === RoleType.KnowledgeProvider ||
                r.name === RoleType.Admin
            )
            ?.map((e: any) => ({
              label: RoleTypeMap[e.name as keyof typeof RoleTypeMap],
              value: e.id,
            })) || []
        }
      />
    </div>
  );
};

export default SelectRoles;
